import { Plate as PlateType } from "../../../../../../pages/api/plata/get";

type PlataProps = {
    plata: PlateType;
};

export default function Plata({ plata }: PlataProps) {
    return (
        <div
            className={`job-shadow border mb-4 pl-8 transition-all duration-300 rounded-xl md:min-h-[118px] w-full flex flex-col md:flex-row justify-between md:items-center transform hover:-translate-y-1 py-6 md:py-6`}
        >
            <div className="flex mb:mr-7 items-center pb-4 md:pb-0">
                <div className="">
                    <h3 className="font-medium">{plata.pozicija.name}</h3>
                    <div className="">
                        <div className="text-gray-dark font-light">
                            {plata._count.netoPlata > 1 &&
                            plata._count.netoPlata < 5
                                ? "Unesene"
                                : "Uneseno"}{" "}
                            {plata._count.netoPlata}{" "}
                            {plata._count.netoPlata > 1 &&
                            plata._count.netoPlata < 5
                                ? "plate"
                                : "plata"}
                        </div>
                    </div>
                </div>
            </div>
            <div className={`grid grid-cols-3 max-w-lg w-full`}>
                <div>
                    <div className="flex text-gray-dark text-sm items-center">
                        <div>Prosječna neto plata</div>
                    </div>
                    <div className="md:mt-2 font-medium">
                        {plata._avg.netoPlata} KM
                    </div>
                </div>
                <div>
                    <div className="flex text-gray-dark text-sm items-center">
                        <div>Godišnji bonus</div>
                    </div>
                    <div className="md:mt-2 font-medium">
                        {plata._avg.godisnjiBonus} KM
                    </div>
                </div>
                <div>
                    <div className="flex text-gray-dark text-sm items-center">
                        <div>Najniža</div>
                    </div>
                    <div className="md:mt-2 font-medium">
                        {plata._min.netoPlata} KM
                    </div>
                    {/* <div className="flex text-gray-dark text-sm items-center">
                        <div>Najviša</div>
                    </div>
                    <div className="md:mt-2 font-medium">
                        {plata._max.netoPlata} KM
                    </div> */}
                </div>
            </div>
        </div>
    );
}
